// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
	--video-container-padding: 0px;
	--video-container-gap: 10px;
}

.video-container {
    background-color: var(--video-container-background-color);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
}


.video-container.over-playback-bar {
	height: calc(100% - var(--playback-bar-height) - 30px);
	top: 0px;
	transform: none;
}

.base-video-rect {
    background-color: var(--base-video-rect-background-color);
    position: relative;
}

.base-video-rect.dynamic {
	display: flex;
	background-color: transparent;
	gap: var(--video-container-gap);
	padding: var(--video-container-padding);
	box-sizing: border-box;
	width: 100%;
	height: 100%;
}

.base-video-rect.dynamic.portrait {
	flex-wrap: wrap;
	align-items: center;
    justify-content: center;
}

.base-video-rect.dynamic.landscape {
	justify-content: space-around;
}

.base-video-rect.dynamic {
	align-items: center;
}

.base-video-rect.dynamic.portrait.align-left {
	justify-content: start;
}

.base-video-rect.dynamic.portrait.align-right {
	justify-content: right;
}

.base-video-rect.dynamic .landscape-container {
	display: flex;
	width: 100%;
	justify-content: space-around;
}

.base-video-rect.dynamic.align-bottom .landscape-container {
	align-items: flex-end;
}

.base-video-rect.dynamic.align-top .landscape-container {
	align-items: flex-start;
}

.base-video-rect.dynamic.align-center .landscape-container {
	align-items: center;
}

.video-container .button-plugins {
    position: absolute;
    top: 10px;
    height: 40px;
	z-index: 100;
}

.video-container .button-plugins.left-side {
    left: 10px;
}

.video-container .button-plugins.right-side {
    right: 10px;
}

.video-container .user-area {
	position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    pointer-events: none;
}

.video-container .button-plugins .button-plugin-container {
	display: inline;
}

.video-container .button-plugins .button-plugin-container button {
	height: var(--button-fixed-height);
	display: block;
	background-color: var(--main-bg-color);
    border-radius: 6px;
	border: none;
	float: left;
	margin-left: 2px;
    margin-right: 2px;
}

.video-container .button-plugins .button-plugin-container button.fixed-width {
	width: var(--button-fixed-width);
}

.video-container .button-plugins .button-plugin-container button.dynamic-width div.interactive-button-content {
	display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}

.video-container .button-plugins button.dynamic-width span {
	margin-top: 0px;
	color: var(--main-fg-color);
	padding-left: 3px;
	padding-right: 3px;
}

.video-container .button-plugins button:hover {
	background-color: var(--highlight-bg-color-hover);
}

.video-container .button-plugins button:active {
	background-color: var(--main-bg-color-hover);
}

.video-container .button-plugins button i {
	background-size: 50% 50%;
	width: 20px;
	display: block;
	background-repeat: no-repeat;
	background-position: 3px 7px;
	margin-left: 5px;
}

.video-container .button-plugins button i svg {
	width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
	color: var(--main-fg-color);
}



/* non-interactive buttons */
.video-container .button-plugins .button-plugin-container div.non-interactive {
	height: var(--button-fixed-height);
	background-color: transparent;
    border-radius: 6px;
	border: none;
	float: left;
	box-sizing: border-box;
	display: flex;
    align-items: center;
    justify-content: center;
	pointer-events: none;
}

.video-container .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {
	display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}

.video-container .button-plugins .button-plugin-container div.non-interactive.fixed-width {
	width: var(--button-fixed-width);
}

.video-container .button-plugins div i {
	background-size: 50% 50%;
	width: 20px;
	display: block;
	background-repeat: no-repeat;
	background-position: 3px 7px;
	margin-left: auto;
	margin-right: auto;
}

.video-container .button-plugins div i svg {
	width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
	color: var(--main-fg-color);
}

.video-container .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {
	display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
}

.video-container .button-plugins div.non-interactive span {
	display: block;
	text-align: center;
}

.video-container .button-plugins div.no-icon span {
	line-height: var(--button-fixed-height);
    margin-top: 0px;
	color: var(--main-fg-color);
}

.video-container .button-plugins div.dynamic-width span {
	margin-top: 0px;
	color: var(--main-fg-color);
	padding-left: 3px;
	padding-right: 3px;
}

.video-container .button-plugin-side-area {
	display: inline;
	color: var(--main-fg-color);
	height: 40px;
	line-height: 40px;
}

.video-container .landscape-container {
	gap: 7px;
}`, "",{"version":3,"sources":["webpack://./src/css/VideoContainer.css"],"names":[],"mappings":";AACA;CACC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;IACI,yDAAyD;IACzD,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;CAC1B,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;AAC5B;;;AAGA;CACC,sDAAsD;CACtD,QAAQ;CACR,eAAe;AAChB;;AAEA;IACI,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;CACC,aAAa;CACb,6BAA6B;CAC7B,+BAA+B;CAC/B,uCAAuC;CACvC,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,mBAAmB;IAChB,uBAAuB;AAC3B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;CACf,YAAY;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;CACC,kBAAkB;IACf,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,cAAc;CACd,sCAAsC;IACnC,kBAAkB;CACrB,YAAY;CACZ,WAAW;CACX,gBAAgB;IACb,iBAAiB;AACrB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;CAC5B,gBAAgB;AACjB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,0BAA0B;CAC7B,2BAA2B;AAC5B;;;;AAIA,4BAA4B;AAC5B;CACC,kCAAkC;CAClC,6BAA6B;IAC1B,kBAAkB;CACrB,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,aAAa;IACV,mBAAmB;IACnB,uBAAuB;CAC1B,oBAAoB;AACrB;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,0BAA0B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;IACpC,eAAe;CAClB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,QAAQ;AACT","sourcesContent":["\n:root {\n\t--video-container-padding: 0px;\n\t--video-container-gap: 10px;\n}\n\n.video-container {\n    background-color: var(--video-container-background-color);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n\n.video-container.over-playback-bar {\n\theight: calc(100% - var(--playback-bar-height) - 30px);\n\ttop: 0px;\n\ttransform: none;\n}\n\n.base-video-rect {\n    background-color: var(--base-video-rect-background-color);\n    position: relative;\n}\n\n.base-video-rect.dynamic {\n\tdisplay: flex;\n\tbackground-color: transparent;\n\tgap: var(--video-container-gap);\n\tpadding: var(--video-container-padding);\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.base-video-rect.dynamic.portrait {\n\tflex-wrap: wrap;\n\talign-items: center;\n    justify-content: center;\n}\n\n.base-video-rect.dynamic.landscape {\n\tjustify-content: space-around;\n}\n\n.base-video-rect.dynamic {\n\talign-items: center;\n}\n\n.base-video-rect.dynamic.portrait.align-left {\n\tjustify-content: start;\n}\n\n.base-video-rect.dynamic.portrait.align-right {\n\tjustify-content: right;\n}\n\n.base-video-rect.dynamic .landscape-container {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-around;\n}\n\n.base-video-rect.dynamic.align-bottom .landscape-container {\n\talign-items: flex-end;\n}\n\n.base-video-rect.dynamic.align-top .landscape-container {\n\talign-items: flex-start;\n}\n\n.base-video-rect.dynamic.align-center .landscape-container {\n\talign-items: center;\n}\n\n.video-container .button-plugins {\n    position: absolute;\n    top: 10px;\n    height: 40px;\n\tz-index: 100;\n}\n\n.video-container .button-plugins.left-side {\n    left: 10px;\n}\n\n.video-container .button-plugins.right-side {\n    right: 10px;\n}\n\n.video-container .user-area {\n\tposition: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    pointer-events: none;\n}\n\n.video-container .button-plugins .button-plugin-container {\n\tdisplay: inline;\n}\n\n.video-container .button-plugins .button-plugin-container button {\n\theight: var(--button-fixed-height);\n\tdisplay: block;\n\tbackground-color: var(--main-bg-color);\n    border-radius: 6px;\n\tborder: none;\n\tfloat: left;\n\tmargin-left: 2px;\n    margin-right: 2px;\n}\n\n.video-container .button-plugins .button-plugin-container button.fixed-width {\n\twidth: var(--button-fixed-width);\n}\n\n.video-container .button-plugins .button-plugin-container button.dynamic-width div.interactive-button-content {\n\tdisplay: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n}\n\n.video-container .button-plugins button.dynamic-width span {\n\tmargin-top: 0px;\n\tcolor: var(--main-fg-color);\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n}\n\n.video-container .button-plugins button:hover {\n\tbackground-color: var(--highlight-bg-color-hover);\n}\n\n.video-container .button-plugins button:active {\n\tbackground-color: var(--main-bg-color-hover);\n}\n\n.video-container .button-plugins button i {\n\tbackground-size: 50% 50%;\n\twidth: 20px;\n\tdisplay: block;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 3px 7px;\n\tmargin-left: 5px;\n}\n\n.video-container .button-plugins button i svg {\n\twidth: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n\tcolor: var(--main-fg-color);\n}\n\n\n\n/* non-interactive buttons */\n.video-container .button-plugins .button-plugin-container div.non-interactive {\n\theight: var(--button-fixed-height);\n\tbackground-color: transparent;\n    border-radius: 6px;\n\tborder: none;\n\tfloat: left;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n    align-items: center;\n    justify-content: center;\n\tpointer-events: none;\n}\n\n.video-container .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {\n\tdisplay: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n}\n\n.video-container .button-plugins .button-plugin-container div.non-interactive.fixed-width {\n\twidth: var(--button-fixed-width);\n}\n\n.video-container .button-plugins div i {\n\tbackground-size: 50% 50%;\n\twidth: 20px;\n\tdisplay: block;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 3px 7px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.video-container .button-plugins div i svg {\n\twidth: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n\tcolor: var(--main-fg-color);\n}\n\n.video-container .button-plugins .button-plugin-container div.dynamic-width div.non-interactive-button-content {\n\tdisplay: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n}\n\n.video-container .button-plugins div.non-interactive span {\n\tdisplay: block;\n\ttext-align: center;\n}\n\n.video-container .button-plugins div.no-icon span {\n\tline-height: var(--button-fixed-height);\n    margin-top: 0px;\n\tcolor: var(--main-fg-color);\n}\n\n.video-container .button-plugins div.dynamic-width span {\n\tmargin-top: 0px;\n\tcolor: var(--main-fg-color);\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n}\n\n.video-container .button-plugin-side-area {\n\tdisplay: inline;\n\tcolor: var(--main-fg-color);\n\theight: 40px;\n\tline-height: 40px;\n}\n\n.video-container .landscape-container {\n\tgap: 7px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
